import dayjs from "dayjs";

import { DateString } from "./types";

function generateParseDateStr(format: string) {
  return function parse(dateString: DateString) {
    return dayjs(dateString, format);
  };
}

export const parseDateStrYmdFullHyphens = generateParseDateStr("YYYY-MM-DD");
